import { render } from "./ModificaRapportino.vue?vue&type=template&id=280d0f22&scoped=true"
import script from "./ModificaRapportino.vue?vue&type=script&lang=js"
export * from "./ModificaRapportino.vue?vue&type=script&lang=js"

import "./ModificaRapportino.vue?vue&type=style&index=0&id=280d0f22&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_puma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280d0f22"]])

export default __exports__